// frontend/src/api/client.js
// Funciones API para la gestión de clientes MAP.

import { request } from './api';

/**
 * @function getAllClients
 * @description Obtiene una lista de todos los clientes del backend.
 * @param {string} token - Token JWT para autorización.
 * @param {object} [filters={}] - Objeto con filtros opcionales (opportunityNumber, accountManager, solutionSales).
 * @returns {Promise<Array<object>>} - Una promesa que resuelve con un array de objetos cliente.
 */
export async function getAllClients(token, filters = {}) { // Corregido: eliminado 'function' duplicado
  const queryParams = new URLSearchParams(filters).toString();
  const endpoint = `/api/clients${queryParams ? `?${queryParams}` : ''}`;
  return request(endpoint, 'GET', null, token);
}

/**
 * @function getClientById
 * @description Obtiene los detalles de un cliente específico por su ID.
 * @param {string} clientId - El ID único del cliente.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - Una promesa que resuelve con el objeto cliente.
 */
export async function getClientById(clientId, token) { // Corregido: eliminado 'function' duplicado
  return request(`/api/clients/${clientId}`, 'GET', null, token);
}

/**
 * @function createClient
 * @description Crea un nuevo cliente en el backend.
 * @param {object} clientData - Objeto con los datos del nuevo cliente.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - Una promesa que resuelve con el cliente creado.
 */
export async function createClient(clientData, token) {
  return request('/api/clients', 'POST', clientData, token);
}

/**
 * @function updateClient
 * @description Actualiza un cliente existente en el backend.
 * @param {string} clientId - El ID único del cliente a actualizar.
 * @param {object} clientData - Objeto con los datos actualizados del cliente.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - Una promesa que resuelve con el cliente actualizado.
 */
export async function updateClient(clientId, clientData, token) {
  return request(`/api/clients/${clientId}`, 'PUT', clientData, token);
}

/**
 * @function deleteClient
 * @description Elimina un cliente del backend.
 * @param {string} clientId - El ID único del cliente a eliminar.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - Una promesa que resuelve cuando el cliente ha sido eliminado (respuesta vacía).
 */
export async function deleteClient(clientId, token) {
  return request(`/api/clients/${clientId}`, 'DELETE', null, token);
}
